import { useState } from "react"

import { App, Flex, Space, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import InputComponent from "../../../../Components/Input"
import { useExternalDemoMode } from "../../../../hooks/useExternalDemoMode"
import AppUtils from "../../../../Utils/utils"
import ReferralActions from "../../../Referrals/reducer"

const { Text } = Typography

const InviteByEmail = () => {
  const dispatch = useDispatch()
  const { notification } = App.useApp()
  const externalDemoMode = useExternalDemoMode()
  const { userInfo } = useSelector((state) => state.auth)
  const [email, setEmail] = useState("")
  const message = useSelector((state) => state?.referrals?.message)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleChangeSearch = (e) => {
    const value = e.target.value
    setEmail(value)
  }

  const sendInvite = () => {
    const data = { referrer_email: email }
    if (!AppUtils.validateEmail(email)) {
      notification.error({
        message: "Email is invalid",
        closeIcon: <Text>{t("Dismiss")}</Text>
      })
      return
    }
    if (email) {
      dispatch(
        ReferralActions.inviteByEmailRequest({
          data,
          onSuccess: (res) => {
            notification.success({
              message: t("Invitation sent successfully"),
              description: res?.message,
              closeIcon: <Text>{t("Dismiss")}</Text>
            })
            setEmail("")
          }
        })
      )
    }
  }

  return (
    <Space direction="vertical" size={8} className="share-link">
      <Text>{t("Enter an email to send a referral invitation")}</Text>
      <Flex>
        <Space
          size={12}
          style={{ flexDirection: isMobile && "column" }}
          className="share-link__row"
        >
          <InputComponent
            value={email}
            type="email"
            placeholder={t("Enter an email ")}
            onChange={handleChangeSearch}
            style={{ width: !isMobile ? "433px" : "100%" }}
          />
          <ButtonComponent
            onClick={externalDemoMode ? null : sendInvite}
            size="large"
            disabled={userInfo?.is_demo}
          >
            {t("Send Invite")}
          </ButtonComponent>
        </Space>
      </Flex>
    </Space>
  )
}

export default InviteByEmail
